import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filteredReports: [], // initial empty array
  newfilteredReports: [],
  followupReports: [],
  otherExpenses:[]
};

const filteredDataSlice = createSlice({
  name: "filteredData",
  initialState,
  reducers: {
    setFilteredReports: (state, action) => {
      state.filteredReports = action.payload;
    },
    setNewfilteredReports: (state, action) => {
      state.newfilteredReports = action.payload;
    },
    setFollowupReports: (state, action) => {
      state.followupReports = action.payload;
    },
    setOtheeExpensesData: (state, action) => {
      state.otherExpenses = action.payload;
    },
  },
});

export const { setFilteredReports, setNewfilteredReports, setFollowupReports,setOtheeExpensesData } =
  filteredDataSlice.actions;

export default filteredDataSlice.reducer;
